import React from 'react';
import { Logo } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Box, Text, Flex, Link } from 'rebass/styled-components';
import AuthSideBar from 'components/atoms/authSideBar';

const SessionLayout = ({ title, subtitle, children }) => (
  <Flex flex="1" minHeight="100vh">
    <Flex flex="1" p="32px" pb="24px" sx={{ position: 'relative', flexDirection: 'column', gap: '40px' }}>
      <Link href="/">
        <Logo width="120px" />
      </Link>
      <Flex
        sx={{
          width: '100%',
          maxWidth: '360px',
          my: '0',
          mx: 'auto',
          justifyContent: 'center',
          flexGrow: 1,
          flexDirection: 'column',
        }}
      >
        {title && (
          <Text as="h1" fontSize="28px" fontWeight="bold" color="text.dark">
            {title}
          </Text>
        )}
        {subtitle && (
          <Text mt="16px" fontSize="18px" fontWeight="medium">
            {subtitle}
          </Text>
        )}
        <Box>{children}</Box>
      </Flex>
      <Flex sx={{ gap: '8px', justifyContent: 'center' }}>
        <Link
          href="https://www.getro.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          fontSize="12px"
          color="text.subtle"
        >
          Terms of service
        </Link>
        <Text color="text.subtle">·</Text>
        <Link
          href="https://www.getro.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          fontSize="12px"
          color="text.subtle"
        >
          Privacy policy
        </Link>
      </Flex>
    </Flex>
    <Box width="480px" display={['none', 'none', 'flex']} alignItems="center" justifyContent="flex-end">
      <AuthSideBar />
    </Box>
  </Flex>
);

SessionLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

SessionLayout.defaultProps = {
  children: null,
  title: null,
  subtitle: null,
};

export default SessionLayout;
